import timeToInitialDecisionFrEdAss from './timeToInitialDecisionFrEdAss';

export default timeToInitialDecisionFrEdAss;